import React, { useContext, useEffect, useCallback } from "react"
import { section, header, columns, inputGroup, label, infoProducts, servicesList } from "./products.module.css"

import { CartContext } from "src/context/CartContext"
import Card from "src/components/core/atoms/card"
import Button from "src/components/core/atoms/button"
import ItemNotes from "src/components/core/molecules/itemNotes"
import { Trash2 } from "react-feather"
import Dropdown from "src/components/core/atoms/dropdown"

const ProductCard = ({ item }) => {
  const {
    cartData,
    setCount,
    dispatchCart,
    ACTIONS,
    locations,
    dateTimes,
  } = useContext(CartContext)

  const cartItem = cartData.filter( cartItem => cartItem.product_id === item.product_id )[ 0 ]

  const handleDropdownChange = ( e, value ) => {
    const itemType = value[ 1 ].type
    const itemElem = value[ 1 ].elem
    const newValue = {
      ...cartItem[ itemType ],
      [ itemElem ]: value[ 0 ]
    }

    const newItem = {
      ...cartItem,
      [ itemType ]: { ...newValue }
    }

    dispatchCart( { type: ACTIONS.CART_UPDATE_ITEM, payload: newItem } )
  }

  const reloader = useCallback( () => {
    setCount(prevState => ({
      ...prevState,
      [ item.product_id ]: cartItem ? cartItem.quantity : 0,
    }))
  }, [ cartItem, item.product_id, setCount ] )

  useEffect(() => {
    reloader()
  }, [ reloader ] )

  return (
    <Card key={ item.product_id }>
      <div className={ columns }>
        <div>
          <label className={ label } show="sm" htmlFor="name">Service</label>
          <h1 name="name">{item.name}</h1>
        </div>
        <div className={ inputGroup }>
          <label className={ label } show="sm" htmlFor="drop-off">Drop-off</label>
          <div>
            <Dropdown
              name="drop-off-address"
              label="Address"
              args={ { type: 'drop_off', elem: 'address', id: item._id } }
              options={ locations }
              value={ item.drop_off.address }
              onChange={ handleDropdownChange }
            />
            <Dropdown
              label="Time"
              name="drop-off-time"
              args={ { type: 'drop_off', elem: 'time', id: item._id } }
              options={ dateTimes }
              value={ item.drop_off.time }
              onChange={ handleDropdownChange }
            />
          </div>
        </div>
        <div className={ inputGroup }>
          <label className={ label } show="sm" htmlFor="pickup-address">Pickup</label>
          <div>
            <Dropdown
              label="Address"
              name="pickup-address"
              args={ { type: 'pickup', elem: 'address', id: item._id } }
              options={ locations }
              value={ item.pickup.address }
              onChange={ handleDropdownChange }
            />
            <Dropdown
              label="Time"
              name="pickup-time"
              args={ { type: 'pickup', elem: 'time', id: item._id } }
              options={ dateTimes }
              value={ item.pickup.time }
              onChange={ handleDropdownChange }
            />
          </div>
        </div>
        <div className={ inputGroup }>
          <label className={ label } htmlFor="quantity">Quantity</label>
          <Button
            name="quantity"
            variant="quantity"
            reloader={reloader}
            item={item}
          />
        </div>
        <div className={ inputGroup }>
          <label className={ label } htmlFor="remove">Remove</label>
          <Button
            name="remove"
            variant="text"
            leftIcon={<Trash2 />}
            onClick={() => {
              dispatchCart({
                type: ACTIONS.CART_REMOVE_ITEM,
                payload: item._id,
              })
              reloader()
            }}
          />
        </div>
      </div>
      <ItemNotes item={item} label="Add timesheet note" />
    </Card>
  )
}

const InfoProducts = () => {
  const { cartData } = useContext(CartContext)

  return (
    <div className={ infoProducts }>
      <section className={ section }>
        <header className={ `${ columns } ${ header }` }>
          <label htmlFor="name" className={ label } show="lg">Service</label>
          <label htmlFor="drop-off" className={ label } show="lg">Drop-off</label>
          <label htmlFor="pickup-address" className={ label } show="lg">Pickup</label>
          <label htmlFor="quantity" className={ label } show="lg">&nbsp;</label>
          <label htmlFor="remove" className={ label } show="lg">&nbsp;</label>
        </header>
        <div className={ servicesList }>
          {cartData && cartData.length ? (
            cartData.map( item => (
              <ProductCard key={ item._id } item={ item } />
            )
            )
          ) : (
            <article>
              <p>There are no items in your booking.</p>
              <Button variant="link" to="/services">
                Back to Services List
              </Button>
            </article>
          )}
        </div>
      </section>
    </div>
  )
}

export default InfoProducts
